@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px">
    <h3 style="margin: 0">Urit</h3>
    <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
      Käyttäjän tallentamat tiedot: <a [href]="(luetteloKirjanpidoistaUritObservable | async).uri" target="_BLANK">{{ (luetteloKirjanpidoistaUritObservable | async).display }}</a>
    </div>
  </div>
}

<ng-container>
  @if (luetteloKirjanpidoistaObservable | async; as data) {
    <!-- Lataus-painike -->
    <div style="display: flex; justify-content: space-between">
      <button mat-icon-button type="button" (click)="downloadPdf()">
        <div class="pdf-btn">
          <div>PDF</div>
          <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
        </div>
      </button>
    </div>
    <!-- Rekisteröity-huomautus-->
    @if (data.lukittu) {
      <div style="padding: 3em; font-weight: bold">Tilinpäätös on rekisteröity. Tietoja ei voi enää muokata.</div>
    }
    <div style="text-align: right; padding: 30px 0">
      <!-- Luettelo kirjanpidoista ja aineistoista -esikatselu -->
      <h3 style="padding: 0px 30px" class="otsikko">Luettelo kirjanpidoista ja aineistoista -esikatselu</h3>
      @if (luetteloKirjanpidoistaPdfObservable | async; as pdfUrl) {
        <div class="divider"></div>
        <div app-pdf-viewer [url]="pdfUrl"></div>
        <div class="divider"></div>
      } @else {
        <div style="text-align: center; padding: 50px 0">
          <mat-spinner style="display: inline-block"></mat-spinner>
          <div style="text-align: center; padding: 20px 0">Esikatselua ladataan...</div>
        </div>
      }
      <!-- Lisätiedot-lomake -->
      <h3 style="padding: 0px 30px" class="otsikko">Lisätiedot</h3>
      <form style="margin: 30px 30px">
        <mat-form-field>
          <textarea matInput [formField]="lomake.lisatiedot" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </form>
      <button mat-button style="text-align: right" class="primarybutton" (click)="tallenna()" [disabled]="data.lukittu">Tallenna</button>
    </div>
  }
</ng-container>
